/* eslint-disable arrow-body-style */
// @flow
import React, { useState, useEffect } from 'react';
import { t } from 'javascripts/utils/withTranslation';
import classNames from 'classnames';
import Icon from 'components/_particles/icon/react/Icon';
import IconLink, {
  accessibilityLinkText,
} from 'components/atoms/icon-link/react/IconLink';
import type { BurgerProps, NavigationSubItem, ToggleProps } from '../types';
import Back from './Back';

const BurgerContentSubmenu = ({
  setStepKey,
  activeItem,
}: BurgerProps): React$MixedElement => {
  const [flatActiveItem, setFlatActiveItem] =
    useState<NavigationSubItem | void>();

  useEffect(() => {
    if (activeItem) {
      const arrayFlat: NavigationSubItem = {
        ...activeItem,
        children: activeItem?.children?.flat(),
      };
      setFlatActiveItem(arrayFlat);
    }
  }, [activeItem]);

  return (
    <div className="burger__content burger__content--sub">
      <div className="burger__inner">
        <Back setStepKey={setStepKey} />

        {flatActiveItem && (
          <nav aria-labelledby="#sub-headline" className="burger__nav">
            <a
              className="icon-link burger__overview-link"
              href={flatActiveItem.link}
              id="list-headline"
            >
              <span className="icon-link__text">{flatActiveItem.title}</span>
              <span className="icon-link__button">
                <Icon icon="arrow-right-line" className="icon-link__icon" />
              </span>
            </a>
            <ul className="burger__list" aria-labelledby="#list-headline">
              {flatActiveItem.children?.map((item, index) => (
                <li key={index} className="burger__list-item ">
                  <a
                    href={item.link}
                    className={classNames(
                      'burger__link burger__link--headline',
                      item.target === '_blank' && 'link--external'
                    )}
                  >
                    <span className="burger__link-text">
                      {accessibilityLinkText(
                        item.target === '_blank' ? 'external' : '',
                        item.target === '_blank',
                        item.title
                      )}
                    </span>
                  </a>

                  {item.children && (
                    <ul className="burger__sub">
                      {item.children.map((subItem, subIndex) => (
                        <li key={subIndex} className="burger__list-item">
                          <a
                            href={subItem.link}
                            className={classNames(
                              'burger__link',
                              subItem.target === '_blank' && 'link--external'
                            )}
                          >
                            <span className="burger__link-text">
                              {accessibilityLinkText(
                                subItem.target === '_blank' ? 'external' : '',
                                subItem.target === '_blank',
                                subItem.title
                              )}
                            </span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </div>
  );
};

export default BurgerContentSubmenu;
